import { on } from "@ember/modifier";
import { t } from "ember-intl";
import Header from "glesys-controlpanel/components/g-modal/header";
import Body from "glesys-controlpanel/components/g-modal/body";
import Footer from "glesys-controlpanel/components/g-modal/footer";
import modalClose from "glesys-controlpanel/helpers/modal-close";
import GButton from "glesys-controlpanel/components/g-button";

<template>
  <Header data-test-modal-info-title>
    {{@params.titleText}}
  </Header>
  <Body>
    <p class="leading-normal text-base text-gray-500 mb-6" data-test-modal-info-text>
      {{@params.text}}
    </p>
  </Body>
  <Footer>
    <GButton
      data-test-modal-info-close
      @color={{if @params.buttonColor @params.buttonColor "gray"}}
      {{on "click" (modalClose)}}
    >
      {{if @params.buttonText @params.buttonText (t "button.close")}}
    </GButton>
  </Footer>
</template>
